import { useLoadingStore } from "@/stores/loading"
import type { AxiosError, AxiosInstance, AxiosResponse } from "axios"
import type { CustomAxiosRequestConfig } from "./interface"

export function setupLoadingInterceptor(axiosInstance: AxiosInstance) {

  // Requisição
  axiosInstance.interceptors.request.use(

    // Envio
    (config: CustomAxiosRequestConfig) => {
      if (!config.skipLoading) {
        useLoadingStore().startLoading();
      }

      return config;


    },

    // Erro
    (error) => {
      useLoadingStore().stopLoading();
      return Promise.reject(error);
    });


  // Resposta
  axiosInstance.interceptors.response.use(

    // Successo
    (response: AxiosResponse) => {
      const config = response.config as any

      if (!config.skipLoading) {
        useLoadingStore().stopLoading()
      }
      return {
        ...response
      }
    },

    // Erro
    (error: AxiosError) => {
      const config = error.config as any
      if (!config?.skipLoading) {
        useLoadingStore().stopLoading()
      }

      return Promise.reject(error)
    }
  )
}